import css from 'styled-jsx/css'

import { colors } from '../../../theme'
import common from '../../../theme/common'
import sizes from '../../../theme/sizes'


export default css`
  .route {
    display: flex;
    align-items: center;
    margin-bottom: 3rem;
    position: relative;
  }

  .route :global(a) {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    color: ${colors.pureWhite};
    transition: opacity 150ms ease;
    z-index: 1;
  }



  .route :global(.cloud) {
    opacity: 0;
    transform: scale(0) rotate(10deg);
    width: 7rem;
    height: 7rem;
    transition: opacity 150ms ease, transform 150ms cubic-bezier(0.5, 1.5, 0.5, 1.5);
    user-select: none;
  }

  .route :global(.cloud img) {
    width: 100%;
    height: 100%;
  }

  .route :global(.image-wrapper) {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
    transform: translateY(30%) translateX(-20%);
    opacity: 0;
    transition: all .4s ease;
    pointer-events: none;
  }

  .route :global(.image) {
    width: 350px;
    transform: rotate(0deg);
    transition: all .4s ease;
  }

  .route :global(.label) {
    ${common.h2};

    color: rgba(255, 255, 255, .3);
    line-height: inherit;
    transition: opacity 150ms ease, color .3s ease;
    white-space: nowrap;
  }

  .route :hover :global(.label) {
    color: ${colors.pureWhite};
  }

  .route.selected :global(.cloud) {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }

    
  @media screen and (min-width: ${sizes.media.tablet.endMaxWidth}) {
    .route :global(a .link):hover .label {
      opacity: 0.8;
    }
  
    .route:not(.selected) :global(.link:hover .label) {
      opacity: 1;
    }

    .route :hover :global(.image-wrapper) {
      opacity: 1;
      transform: translateY(50%) translateX(30px);
    }

    .route :hover :global(.image) {
      transform: rotate(10deg);
    }
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .route {
      margin-bottom: 1rem;
    }
  
    .route :global(.label) {
      ${common.h4}
      letter-spacing: 0.07rem;
      white-space: normal;
      text-align: right;
      color: ${colors.pureWhite};
    }

    .route :global(.cloud) {
      width: 4rem;
      height: 4rem;
    }
  }
`
